import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyle = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            contentWrapper: css({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                gap: theme.orbitalThree,
                height: '100%',
            }),
            card: css({
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'center',
            }),
            title: css({
                display: 'flex',
                alignItems: 'center',
                margin: theme.orbitalFour,
                fontWeight: 'bold',
            }),
            textWrapper: css({
                maxWidth: '400px',
            }),
            icon: css({
                marginRight: theme.orbitalTwo,
            }),
            button: css({
                width: '100%',
            }),
            actions: css({
                display: 'flex',
                flexDirection: 'column',
                gap: theme.orbitalFour,
            }),
        }),
        [theme.orbitalFour, theme.orbitalThree, theme.orbitalTwo]
    );
};

export default useStyle;
